module.exports = __webpack_public_path__ + "static/media/routes12.f67835be.webp";